import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import { setDefaultAddress } from '@/modules/address/application/setDefaultAddress';
import type { Address } from '@/modules/address/domain/Address';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

export const LABEL_CHANGE_ADDRESS_SUCCESS = '¡Listo! Elegiste una dirección';
export const LABEL_CHANGE_ADDRESS_ERROR = 'No pudimos cambiar la dirección';

const useSelectAddress = (): MutatorHook<Address['id']> => {
  const { addressRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const trigger = async (addressId: Address['id']) => {
    setIsLoading(true);

    try {
      await setDefaultAddress(addressRepository, addressId);
      toast({ title: '¡Listo! Elegiste una dirección' });
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useSelectAddress;
